/* Carrito estilo Amazon — Moon Shop.
   Cambia cantidades sin recargar la página: solo se reemplazan el subtotal, la barra
   de envío y la lista. Los botones de compra (Releasit) no se tocan, así no desaparecen. */
(function () {
  if (window.__amzCarrito) { window.__amzCarrito(); return }

  function cuenta (n) {
    document.querySelectorAll('[data-amz-cuenta]').forEach(function (el) { el.textContent = n; el.hidden = !n })
  }

  function cambiar (raiz, linea, cantidad) {
    var sid = raiz.dataset.seccion
    raiz.classList.add('is-cargando')
    return fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ line: Number(linea), quantity: cantidad, sections: [sid], sections_url: location.pathname }) })
      .then(function (r) { if (!r.ok) return r.json().then(function (e) { throw new Error(e.description || e.message || 'No se pudo cambiar') }); return r.json() })
      .then(function (c) {
        cuenta(c.item_count)
        if (!c.item_count || !c.sections || !c.sections[sid]) { location.reload(); return }
        var nuevo = new DOMParser().parseFromString(c.sections[sid], 'text/html')
        raiz.querySelectorAll('[data-amz-parte]').forEach(function (viejo) {
          var otro = nuevo.querySelector('[data-amz-parte="' + viejo.dataset.amzParte + '"]')
          if (otro) viejo.replaceWith(otro)
        })
        document.dispatchEvent(new CustomEvent('amz:carrito', { detail: c }))
      })
      .catch(function (e) { alert(e.message) })
      .finally(function () { raiz.classList.remove('is-cargando') })
  }

  function carrito () {
    document.querySelectorAll('[data-amz-carrito]').forEach(function (raiz) {
      if (raiz.dataset.amzListo) return; raiz.dataset.amzListo = '1'
      raiz.addEventListener('click', function (e) {
        var item = e.target.closest('.amzk__item'); if (!item) return
        var linea = item.dataset.linea, n = Number(item.dataset.cantidad)
        if (e.target.closest('[data-amz-menos]')) { e.preventDefault(); cambiar(raiz, linea, n - 1) }
        else if (e.target.closest('[data-amz-mas]')) { e.preventDefault(); cambiar(raiz, linea, n + 1) }
        else if (e.target.closest('[data-amz-eliminar]')) { e.preventDefault(); cambiar(raiz, linea, 0) }
        else if (e.target.closest('[data-amz-compartir]')) {
          e.preventDefault()
          var url = item.dataset.url, nombre = (item.querySelector('.amzk__nombre') || {}).textContent || ''
          if (navigator.share) navigator.share({ title: nombre.trim(), url: url }).catch(function () {})
          else if (navigator.clipboard) navigator.clipboard.writeText(url).then(function () { alert('Enlace copiado') })
        }
      })
      var nota = raiz.querySelector('[data-amz-nota]')
      if (nota) nota.addEventListener('change', function () {
        fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ note: nota.value }) })
      })
    })
  }

  function recomendados () {
    document.querySelectorAll('[data-amz-relacionados]').forEach(function (s) {
      if (s.dataset.amzListo) return; s.dataset.amzListo = '1'
      /* 19-oct (Pablo): parecidos a TODO lo que lleva, no solo al primero. Una dirección por
         producto del carrito; se intercalan (1.º de cada uno, 2.º de cada uno…) sin repetir. */
      var urls = String(s.dataset.amzRelacionados).split('|').filter(Boolean), cuantos = Number(s.dataset.cuantos || 10)
      function clave (t) { var a = t.querySelector('a[data-enlace]'), m = a && String(a.getAttribute('href') || '').match(/\/products\/([^?#\/]+)/); return m ? decodeURIComponent(m[1]).toLowerCase() : '' }
      Promise.all(urls.map(function (u) {
        return fetch(u).then(function (r) { return r.ok ? r.text() : '' }).then(function (html) {
          var d = new DOMParser().parseFromString(html, 'text/html'), c = d.querySelector('[data-amz-recomendados]')
          return c ? Array.prototype.slice.call(c.children) : []
        }).catch(function () { return [] })
      })).then(function (listas) {
        var viejo = s.querySelector('[data-amz-recomendados]'); if (!viejo) return
        var ya = {}, salen = [], i = 0, hay = true
        while (salen.length < cuantos && hay) {
          hay = false
          listas.forEach(function (l) {
            var t = l[i]; if (!t) return; hay = true
            var k = clave(t); if (salen.length >= cuantos || (k && ya[k])) return
            if (k) ya[k] = 1; salen.push(t)
          })
          i++
        }
        if (!salen.length) return
        viejo.innerHTML = ''; salen.forEach(function (t) { viejo.appendChild(document.importNode(t, true)) }); s.style.display = ''
      })
    })
  }

  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-amz-agregar]'); if (!b || b.disabled) return
    if (b.hasAttribute('data-amzt-agregar-t')) return /* esas tarjetas las maneja amzt.js; sin esto se agregaban dos veces */
    e.preventDefault(); b.disabled = true; var txt = b.textContent
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: Number(b.dataset.amzAgregar), quantity: 1 }) })
      .then(function (r) { if (!r.ok) return r.json().then(function (er) { throw new Error(er.description || 'No se pudo agregar') }) })
      .then(function () {
        if (document.querySelector('[data-amz-carrito]')) { location.reload(); return }
        /* Pablo (29-oct): como en Amazon, lo agregado se queda con su cantidad (basurito · 1 · +) en vez de «Agregado ✓». */
        b.disabled = false; b.textContent = txt
        if (document.querySelector('[data-amzt-carrito]') && window.__amztRefrescarCarrito) window.__amztRefrescarCarrito()
        leerCarrito(true).then(function (c) { cuenta(c.item_count); pasoSync() })
      })
      .catch(function (er) { alert(er.message); b.disabled = false })
  })

  /* ---------- Cantidad en las tarjetas (basurito · n · +) ---------- */
  var TOPE_T = 30, carritoP = null, enC = {}
  var SVG_BASURA = '<svg viewBox="22 12 46 45" aria-hidden="true" fill="currentColor" style="width:18px;height:18px"><rect x="36" y="14" width="18" height="6" rx="3"/><rect x="24" y="22.5" width="42" height="6.5" rx="3.2"/><path fill-rule="evenodd" d="M30 28.5h30.5L58 52.5Q57.7 55 55 55H35.5Q32.8 55 32.5 52.5ZM36.5 29.5L54.5 29.5L52.8 49H38.3Z"/></svg>'
  var SVG_MENOS = '<svg viewBox="0 0 24 24" aria-hidden="true" style="width:18px;height:18px"><path d="M6 12h12" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"/></svg>'
  var SVG_MAS = '<svg viewBox="0 0 24 24" aria-hidden="true" style="width:18px;height:18px"><path d="M6 12h12M12 6v12" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"/></svg>'
  function leerCarrito (nuevo) {
    if (!carritoP || nuevo) carritoP = fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json() }).then(function (c) {
      enC = {}; (c.items || []).forEach(function (it) { enC[it.variant_id] = (enC[it.variant_id] || 0) + it.quantity }); return c
    })
    return carritoP
  }
  function pasoDe (b) {
    var p = b.nextElementSibling
    if (p && p.classList.contains('amzc-paso')) return p
    p = document.createElement('div'); p.className = 'amzc-paso'
    p.innerHTML = '<button type="button" data-amzc-menos></button><span data-amzc-n>1</span><button type="button" data-amzc-mas aria-label="Agregar uno">' + SVG_MAS + '</button>'
    var cs = getComputedStyle(b); p.style.marginTop = cs.marginTop; p.style.height = b.offsetHeight ? b.offsetHeight + 'px' : ''
    b.parentNode.insertBefore(p, b.nextSibling); return p
  }
  function pintarPaso (b, n) {
    var p = pasoDe(b); p.dataset.v = b.dataset.amzAgregar
    /* Solo se toca lo que cambió: el vigilante de tarjetas nuevas no debe despertarse con estos cambios. */
    var nEl = p.querySelector('[data-amzc-n]'); if (nEl.textContent !== String(n)) nEl.textContent = n
    var m = p.querySelector('[data-amzc-menos]'), forma = n <= 1 ? 'b' : 'm'
    if (m.dataset.forma !== forma) { m.dataset.forma = forma; m.innerHTML = forma === 'b' ? SVG_BASURA : SVG_MENOS; m.setAttribute('aria-label', forma === 'b' ? 'Quitar del carrito' : 'Quitar uno') }
    p.querySelector('[data-amzc-mas]').disabled = n >= TOPE_T
    if (p.style.display !== '') p.style.display = ''; if (b.style.display !== 'none') b.style.display = 'none'
  }
  function quitarPaso (b) { var p = b.nextElementSibling; if (p && p.classList.contains('amzc-paso') && p.style.display !== 'none') p.style.display = 'none'; if (b.style.display) b.style.display = '' }
  function pasoSync () {
    document.querySelectorAll('[data-amz-boton]').forEach(function (b) {
      if (b.hasAttribute('data-amzt-agregar-t')) return
      var v = b.dataset.amzAgregar, n = v ? enC[v] || 0 : 0
      if (n > 0) pintarPaso(b, n); else quitarPaso(b)
    })
  }
  window.__amzPasoSync = pasoSync
  document.addEventListener('click', function (e) {
    var bt = e.target.closest('.amzc-paso [data-amzc-menos], .amzc-paso [data-amzc-mas]'); if (!bt) return
    e.preventDefault(); e.stopPropagation()
    var p = bt.closest('.amzc-paso'); if (p.classList.contains('is-ocupado')) return
    var v = p.dataset.v, n = enC[v] || 0, nuevo = bt.hasAttribute('data-amzc-mas') ? Math.min(TOPE_T, n + 1) : Math.max(0, n - 1)
    p.classList.add('is-ocupado'); p.querySelector('[data-amzc-n]').textContent = nuevo || 1
    fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: String(v), quantity: nuevo }) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || 'No se pudo cambiar la cantidad'); return j }) })
      .then(function () { return leerCarrito(true) })
      .then(function (c) { cuenta(c.item_count); pasoSync(); if (document.querySelector('[data-amzt-carrito]') && window.__amztRefrescarCarrito) window.__amztRefrescarCarrito() })
      .catch(function (er) { alert(er.message); leerCarrito(true).then(pasoSync) })
      .then(function () { p.classList.remove('is-ocupado') })
  }, true)
  /* Las tarjetas que llegan después (más productos al bajar, recomendados) también se revisan. */
  var tSync = null
  new MutationObserver(function (ms) { if (ms.every(function (m) { return m.target.closest && m.target.closest('.amzc-paso') })) return; clearTimeout(tSync); tSync = setTimeout(function () { leerCarrito().then(pasoSync) }, 250) }).observe(document.documentElement, { childList: true, subtree: true })
  leerCarrito().then(pasoSync).catch(function () {})
  window.addEventListener('pageshow', function (e) { if (e.persisted) leerCarrito(true).then(pasoSync) })

  function todo () { carrito(); recomendados() }
  window.__amzCarrito = todo
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', todo); else todo()
  document.addEventListener('shopify:section:load', todo)
})()
